import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const AddContent = () => {
  const [mainTitle, setMainTitle] = useState('');
  const [sections, setSections] = useState([
    {
      id: Date.now(),
      title: '',
      editors: [{ id: Date.now(), content: '' }],
    },
  ]);

  const editorRefs = useRef({});
  const navigate = useNavigate();
  const server_url = process.env.REACT_APP_API_URI;

  const editorConfigs = {
    toolbar: [
      'heading',
      '|',
      'bold',
      'italic',
      'underline',
      'strikethrough',
      'subscript',
      'superscript',
      '|',
      'fontFamily',
      'fontSize',
      'fontColor',
      'fontBackgroundColor',
      '|',
      'alignment',
      '|',
      'bulletedList',
      'numberedList',
      'todoList',
      '|',
      'link',
      'blockQuote',
      'codeBlock',
      '|',
      'insertTable',
      'imageUpload',
      'mediaEmbed',
      '|',
      'undo',
      'redo',
    ],
    fontFamily: {
      options: [
        'default',
        'Arial, Helvetica, sans-serif',
        'Courier New, Courier, monospace',
        'Georgia, serif',
        'Times New Roman, Times, serif',
        'Verdana, Geneva, sans-serif',
      ],
    },
    // fontSize: {
    //   options: [
    //     {
    //       title: 'Tiny',
    //       model: 'tiny',
    //       view: {
    //         name: 'span',
    //         styles: { 'font-size': '10px' }
    //       }
    //     },
    //     {
    //       title: 'Small',
    //       model: 'small',
    //       view: {
    //         name: 'span',
    //         styles: { 'font-size': '12px' }
    //       }
    //     },
    //     {
    //       title: 'Default',
    //       model: 'default',
    //       view: {
    //         name: 'span',
    //         styles: { 'font-size': '16px' }
    //       }
    //     },
    //     {
    //       title: 'Big',
    //       model: 'big',
    //       view: {
    //         name: 'span',
    //         styles: { 'font-size': '20px' }
    //       }
    //     },
    //     {
    //       title: 'Huge',
    //       model: 'huge',
    //       view: {
    //         name: 'span',
    //         styles: { 'font-size': '24px' }
    //       }
    //     }
    //   ],
    //   supportAllValues: false
    // },

    alignment: {
      options: ['left', 'center', 'right', 'justify'],
    },
    table: {
      contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
    },
    image: {
      toolbar: ['imageTextAlternative', 'imageStyle:full', 'imageStyle:side'],
    },
    mediaEmbed: {
      previewsInData: true,
    },
  };

  useEffect(() => {
    const loadCKEditorScript = () => {
      const existingScript = document.querySelector(
        'script[src*="ckeditor.js"]',
      );
      if (!existingScript) {
        const script = document.createElement('script');
        script.src =
          'https://cdn.ckeditor.com/ckeditor5/41.4.2/decoupled-document/ckeditor.js';
        script.onload = initializeEditors;
        document.body.appendChild(script);
      } else {
        initializeEditors();
      }
    };

    const initializeEditors = () => {
      if (!window.DecoupledEditor) return;

      sections.forEach((section) => {
        section.editors.forEach((editor) => {
          const editorId = `editor_${editor.id}`;
          const element = document.getElementById(editorId);
          const toolbarContainer = document.getElementById(
            `toolbar_${editorId}`,
          );
          if (element && toolbarContainer && !editorRefs.current[editorId]) {
            window.DecoupledEditor.create(element, editorConfigs)
              .then((instance) => {
                toolbarContainer.appendChild(instance.ui.view.toolbar.element);
                editorRefs.current[editorId] = instance;
              })
              .catch((error) =>
                console.error(`CKEditor init error for ${editorId}`, error),
              );
          }
        });
      });
    };

    loadCKEditorScript();
  }, [sections]);

  const handleAddSection = () => {
    setSections((prevSections) => [
      ...prevSections,
      {
        id: Date.now(),
        title: '',
        editors: [{ id: Date.now(), content: '' }],
      },
    ]);
  };

  const handleRemoveSection = (id) => {
    const section = sections.find((sec) => sec.id === id);
    section?.editors.forEach((editor) => {
      const instance = editorRefs.current[`editor_${editor.id}`];
      if (instance) {
        instance.destroy();
        delete editorRefs.current[`editor_${editor.id}`];
      }
    });

    setSections(sections.filter((s) => s.id !== id));
  };

  const handleAddEditor = (sectionId) => {
    setSections((prevSections) =>
      prevSections.map((section) =>
        section.id === sectionId
          ? {
              ...section,
              editors: [...section.editors, { id: Date.now(), content: '' }],
            }
          : section,
      ),
    );
  };

  const handleRemoveEditor = (sectionId, editorId) => {
    const instance = editorRefs.current[`editor_${editorId}`];
    if (instance) {
      instance.destroy();
      delete editorRefs.current[`editor_${editorId}`];
    }

    setSections((prevSections) =>
      prevSections.map((section) =>
        section.id === sectionId
          ? {
              ...section,
              editors: section.editors.filter((e) => e.id !== editorId),
            }
          : section,
      ),
    );
  };

  const handleSectionTitleChange = (id, value) => {
    setSections((prevSections) =>
      prevSections.map((section) =>
        section.id === id ? { ...section, title: value } : section,
      ),
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      mainTitle,
      sections: sections.map((section) => ({
        title: section.title,
        contents: section.editors.map((editor) => ({
          content: editorRefs.current[`editor_${editor.id}`]?.getData() || '',
        })),
      })),
    };

    try {
      await axios.post(`${server_url}/content/add-content`, payload);
      alert('Content Added Successfully!');
      navigate('/admin/content');
    } catch (error) {
      console.error('Error saving content:', error);
      alert('Failed to save content');
    }
  };

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">Add Content</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Enter Main Title"
          value={mainTitle}
          onChange={(e) => setMainTitle(e.target.value)}
          className="w-full p-2 border rounded mb-4"
        />

        {sections.map((section, index) => (
          <div
            key={section.id}
            className="mb-6 border border-gray-300 rounded-md p-4 relative"
          >
            <h3 className="text-lg font-semibold">Section {index + 1}</h3>
            <input
              type="text"
              placeholder="Enter Section Title"
              value={section.title}
              onChange={(e) =>
                handleSectionTitleChange(section.id, e.target.value)
              }
              className="w-full p-2 border rounded mb-2"
            />
            {section.editors.map((editor) => (
              <div key={editor.id} className="relative mb-12">
                <div
                  id={`toolbar_editor_${editor.id}`}
                  className="mb-2 bg-gray-100 p-2 border rounded"
                ></div>
                <div
                  id={`editor_${editor.id}`}
                  className="ck-editor__editable_inline"
                  style={{
                    minHeight: '200px',
                    border: '1px solid #ddd',
                    padding: '10px',
                  }}
                ></div>
                <button
                  type="button"
                  onClick={() => handleRemoveEditor(section.id, editor.id)}
                  className="mt-2 px-3 py-1 bg-red-500 text-white rounded-md hover:bg-red-600 float-right"
                >
                  Remove Editor
                </button>
              </div>
            ))}
            <button
              type="button"
              onClick={() => handleAddEditor(section.id)}
              className="mt-2 px-3 py-1 bg-blue-500 text-white rounded-md hover:bg-blue-600"
            >
              Add More Editors
            </button>
            <button
              type="button"
              onClick={() => handleRemoveSection(section.id)}
              className="m-4 px-3 py-1 bg-red-500 text-white rounded-md hover:bg-red-600"
            >
              Remove Section
            </button>
          </div>
        ))}

        <button
          type="button"
          onClick={handleAddSection}
          className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 mr-4"
        >
          Add More Sections
        </button>
        <button
          type="submit"
          className="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600"
        >
          Save
        </button>
      </form>
    </div>
  );
};

export default AddContent;
